export default [
  {
    name: "Jim Vandehei",
    title: "Founder & Chief Executive Officer",
    picture: "http://static.axios.com/img/headshots/JimVandehei.jpg",
  },
  {
    name: "Mike Allen",
    title: "Founder & Executive Director",
    picture: "http://static.axios.com/img/headshots/MikeAllen.jpg",
  },
  {
    name: "Roy Schwartz",
    title: "Founder & President",
    picture: "http://static.axios.com/img/headshots/RoySchwartz.jpg",
  },
  {
    name: "Evan Ryan",
    title: "Executive Vice President",
    picture: "http://static.axios.com/img/headshots/evan_ryan.jpg",
  },
  {
    name: "Alexis Lloyd",
    title: "Chief Design Officer",
    picture: "http://static.axios.com/img/headshots/AlexisLloyd.jpg",
  },
  {
    name: "Matt Boggie",
    title: "Chief Technology Officer",
    picture: "http://static.axios.com/img/headshots/MattBoggie.jpg",
  },
  {
    name: "Kendra Tucker",
    title: "Senior Vice President of Audience and Platforms",
    picture: "http://static.axios.com/img/headshots/kendra_tucker.jpg",
  },
  {
    name: "Nicholas Johnston",
    title: "Editor",
    picture: "http://static.axios.com/img/headshots/NicholasJohnston.jpg",
  },
  {
    name: "Adam Hirsch",
    title: "Systems Architect",
    picture: "https://static.axios.com/img/headshots/adam-hirsch.jpg",
  },
  {
    name: "Adams Paschal",
    title: "Associate Director of External Affairs",
    picture: "https://static.axios.com/img/headshots/adams-paschal.jpg",
  },
  {
    name: "AJ Frucci",
    title: "Vice President of Business Development",
    picture: "https://static.axios.com/img/headshots/aj-frucci.jpg",
  },
  {
    name: "Alayna Treene",
    title: "News Desk Reporter",
    picture: "http://static.axios.com/img/headshots/AlaynaTreene.jpg",
  },
  {
    name: "Alex Duner",
    title: "Front-End Developer",
    picture: "https://static.axios.com/img/headshots/alex-duner.jpg",
  },
  {
    name: "Alexi McCammond",
    title: "Deputy News Desk Editor",
    picture: "https://static.axios.com/img/headshots/alexi-mccammond.jpg",
  },
  {
    name: "Ali Rubin",
    title: "Senior Vice President, External Affairs",
    picture: "http://static.axios.com/img/headshots/AliRubin.jpg",
  },
  {
    name: "Alison Snyder",
    title: "Science Editor",
    picture: "https://static.axios.com/img/headshots/alison-snyder.jpg",
  },
  {
    name: "Amy Harder",
    title: "Energy Reporter",
    picture: "https://static.axios.com/img/headshots/amy-harder.jpg",
  },
  {
    name: "Andrew Witherspoon",
    title: "Data Graphics Designer",
    picture: "https://static.axios.com/img/headshots/andrew-witherspoon.jpg",
  },
  {
    name: "Andy Boyle",
    title: "Director of Platform Architecture",
    picture: "https://static.axios.com/img/headshots/andy-boyle.jpg",
  },
  {
    name: "Becca Rotenberg",
    title: "Social Media Reporter",
    picture: "https://static.axios.com/img/headshots/becca-rotenberg.jpg",
  },
  {
    name: "Ben Geman",
    title: "Energy Reporter",
    picture: "https://static.axios.com/img/headshots/ben-geman.jpg",
  },
  {
    name: "Bob Herman",
    title: "Health Care Business Reporter",
    picture: "https://static.axios.com/img/headshots/bob-herman.jpg",
  },
  {
    name: "Brian Jacobel",
    title: "Front-End Developer",
    picture: "https://static.axios.com/img/headshots/brian-jacobel.jpg",
  },
  {
    name: "Bubba Atkinson",
    title: "Managing Editor",
    picture: "http://static.axios.com/img/headshots/BubbaAtkinson.jpg",
  },
  {
    name: "Caitlin Owens",
    title: "Health Care Reporter",
    picture: "http://static.axios.com/img/headshots/CaitlinOwens.jpg",
  },
  {
    name: "Chris Barna",
    title: "Senior Web Developer",
    picture: "https://static.axios.com/img/headshots/chris-barna.jpg",
  },
  {
    name: "Chris Russell",
    title: "Expert Voices Editor",
    picture: "https://static.axios.com/img/headshots/chris-russell.jpg",
  },
  {
    name: "Chris Canipe",
    title: "Data Graphics Designer",
    picture: "https://static.axios.com/img/headshots/chris-canipe.jpg",
  },
  {
    name: "Christopher Matthews",
    title: "Business Reporter",
    picture: "https://static.axios.com/img/headshots/christopher-matthews.jpg",
  },
  {
    name: "Claire Kennedy",
    title: "Senior Manager, Talent Operations",
    picture: "http://static.axios.com/img/headshots/ClaireKennedy.jpg",
  },
  {
    name: "Colin Chocola",
    title: "Producer, Branded Video",
    picture: "https://static.axios.com/img/headshots/colin-chocola.jpg",
  },
  {
    name: "Dan Primack",
    title: "Business Editor",
    picture: "http://static.axios.com/img/headshots/DanPrimack.jpg",
  },
  {
    name: "Dave Lawler",
    title: "Deputy News Desk Editor",
    picture: "https://static.axios.com/img/headshots/dave-lawler.jpg",
  },
  {
    name: "David McCabe",
    title: "Technology Reporter",
    picture: "http://static.axios.com/img/headshots/DavidMcCabe.jpg",
  },
  {
    name: "David Nather",
    title: "Health Care Editor",
    picture: "http://static.axios.com/img/headshots/DavidNather.jpg",
  },
  {
    name: "Eileen O'Reilly",
    title: "Standards and Style Editor",
    picture: "https://static.axios.com/img/headshots/eileen-oreilly.jpg",
  },
  {
    name: "Eli Sinkus",
    title: "Senior Producer",
    picture: "https://static.axios.com/img/headshots/eli-sinkus.jpg",
  },
  {
    name: "Emma Schwartz",
    title: "Technical Product Manager",
    picture: "https://static.axios.com/img/headshots/emma-schwartz.jpg",
  },
  {
    name: "Erica Pandey",
    title: "News Desk Reporter",
    picture: "https://static.axios.com/img/headshots/erica-pandey.jpg",
  },
  {
    name: "Erin Ross",
    title: "Science Reporter",
    picture: "https://static.axios.com/img/headshots/erin-ross.jpg",
  },
  {
    name: "Gabriel Newman",
    title: "Senior Account Manager",
    picture: "http://static.axios.com/img/headshots/team-placeholder.png",
  },
  {
    name: "Gerald Rich",
    title: "News Developer",
    picture: "https://static.axios.com/img/headshots/gerald-rich.jpg",
  },
  {
    name: "Gloria Kim",
    title: "Senior UX Designer and Researcher",
    picture: "https://static.axios.com/img/headshots/gloria-kim.jpg",
  },
  {
    name: "Greg Rubin",
    title: "Senior Designer",
    picture: "http://static.axios.com/img/headshots/GregRuben.jpg",
  },
  {
    name: "Haley Britzky",
    title: "News Desk Reporter",
    picture: "https://static.axios.com/img/headshots/haley-britzky.jpg",
  },
  {
    name: "Ina Fried",
    title: "Chief Technology Correspondent",
    picture: "https://static.axios.com/img/headshots/ina-fried.jpg",
  },
  {
    name: "Jeff Segal",
    title: "Senior Director of Strategy",
    picture: "https://static.axios.com/img/headshots/jeff-segal.jpg",
  },
  {
    name: "Jillian Sobeck",
    title: "Account Manager",
    picture: "https://static.axios.com/img/headshots/jillian-sobeck.jpg",
  },
  {
    name: "Jonathan Swan",
    title: "National Political Reporter",
    picture: "http://static.axios.com/img/headshots/JonathanSwan.jpg",
  },
  {
    name: "Joyce Kazadi",
    title: "Senior Events Manager",
    picture: "http://static.axios.com/img/headshots/JoyceKazadi.jpg",
  },
  {
    name: "Juliet Bartz",
    title: "Events Associate",
    picture: "https://static.axios.com/img/headshots/juliet-bartz.jpg",
  },
  {
    name: "Justin Green",
    title: "News Desk Editor",
    picture: "http://static.axios.com/img/headshots/JustinGreen.jpg",
  },
  {
    name: "Karina Carlson",
    title: "Events Manager",
    picture: "http://static.axios.com/img/headshots/KarinaCarlson.jpg",
  },
  {
    name: "Kate Meissner",
    title: "Vice President of Business Development",
    picture: "http://static.axios.com/img/headshots/KateGaertner.jpg",
  },
  {
    name: "Kathleen Nisbet",
    title: "Executive Assistant",
    picture: "http://static.axios.com/img/headshots/KathleenNisbet.jpg",
  },
  {
    name: "Kayla Cook",
    title: "Chief of Staff",
    picture: "http://static.axios.com/img/headshots/KaylaCook.jpg",
  },
  {
    name: "Kaylee Knowles",
    title: "Front-End Developer",
    picture: "https://static.axios.com/img/headshots/kaylee-knowles.jpg",
  },
  {
    name: "Kerry McNellis",
    title: "Deputy Director of Events",
    picture: "http://static.axios.com/img/headshots/KerryMcNellis.jpg",
  },
  {
    name: "Kia Kokalitcheva",
    title: "Silicon Valley Reporter",
    picture: "https://static.axios.com/img/headshots/kia-kokalitcheva.jpg",
  },
  {
    name: "Kim Hart",
    title: "Technology Editor",
    picture: "http://static.axios.com/img/headshots/KimHart.jpg",
  },
  {
    name: "Kim Schaich",
    title: "Senior Director",
    picture: "http://static.axios.com/img/headshots/KimSchaich.jpg",
  },
  {
    name: "Kira Luca",
    title: "Senior Advertising Account Manager",
    picture: "https://static.axios.com/img/headshots/kira-luca.jpg",
  },
  {
    name: "Lazaro Gamio",
    title: "Visuals Editor",
    picture: "https://static.axios.com/img/headshots/lazaro-gamino.jpg",
  },
  {
    name: "Leigh Jervey",
    title: "Events Associate, Creative",
    picture: "http://static.axios.com/img/headshots/team-placeholder.png",
  },
  {
    name: "Matt Ross",
    title: "Senior Director of Business Development",
    picture: "https://static.axios.com/img/headshots/matt-ross.jpg",
  },
  {
    name: "Megan Foley",
    title: "Creative Producer, Branded",
    picture: "http://static.axios.com/img/headshots/team-placeholder.png",
  },
  {
    name: "Molly Mitchell",
    title: "Associate Director of Communications",
    picture: "https://static.axios.com/img/headshots/molly-mitchell.jpg",
  },
  {
    name: "Morgan McCloy",
    title: "Video Producer",
    picture: "https://static.axios.com/img/headshots/morgan-mccloy.jpg",
  },
  {
    name: "Morgan Stanley",
    title: "Talent Operations Associate",
    picture: "https://static.axios.com/img/headshots/morgan-stanley.jpg",
  },
  {
    name: "Neal Rothschild",
    title: "Social Media Manager",
    picture: "https://static.axios.com/img/headshots/neal-rothschild.jpg",
  },
  {
    name: "Nick Bisby",
    title: "Systems Architect",
    picture: "https://static.axios.com/img/headshots/nick-bisby.jpg",
  },
  {
    name: "Noa Gutterman",
    title: "Senior Marketing Associate",
    picture: "http://static.axios.com/img/headshots/team-placeholder.png",
  },
  {
    name: "Nora Okonski",
    title: "Advertising Operations Manager",
    picture: "https://static.axios.com/img/headshots/nora-okonski.jpg",
  },
  {
    name: "Rachel Racoonsin",
    title: "Director of Business Development",
    picture: "https://static.axios.com/img/headshots/rachel-racoosin.jpg",
  },
  {
    name: "Rebecca Zisser",
    title: "Graphic Designer",
    picture: "http://static.axios.com/img/headshots/RebeccaZisser.jpg",
  },
  {
    name: "Rob Groulx",
    title: "Director of Video",
    picture: "http://static.axios.com/img/headshots/RobGroulx.jpg",
  },
  {
    name: "Robert Harrison",
    title: "Motion Graphics Designer",
    picture: "https://static.axios.com/img/headshots/robert-harrison.jpg",
  },
  {
    name: "Sam Baker",
    title: "Deputy Health Care Editor",
    picture: "https://static.axios.com/img/headshots/sam-baker.jpg",
  },
  {
    name: "Sam Jacobson",
    title: "Director, Business Development",
    picture: "https://static.axios.com/img/headshots/sam-jacobson.jpg",
  },
  {
    name: "Sam Jayne",
    title: "Art Director",
    picture: "https://static.axios.com/img/headshots/sam-jayne.jpg",
  },
  {
    name: "Sara Fischer",
    title: "Media Reporter",
    picture: "http://static.axios.com/img/headshots/SaraFischer.jpg",
  },
  {
    name: "Shane Savitsky",
    title: "News Desk Reporter",
    picture: "http://static.axios.com/img/headshots/ShaneSavitsky.jpg",
  },
  {
    name: "Shannon Vavra",
    title: "News Desk Reporter",
    picture: "http://static.axios.com/img/headshots/ShannonVavra.jpg",
  },
  {
    name: "Stef W. Kight",
    title: "Social Media Reporter",
    picture: "http://static.axios.com/img/headshots/StefWasko.jpg",
  },
  {
    name: "Steve LeVine",
    title: "Future of Work Editor",
    picture: "https://static.axios.com/img/headshots/steve-levine.jpg",
  },
  {
    name: "Taylor Poulos",
    title: "Product Designer",
    picture: "https://static.axios.com/img/headshots/taylor-poulos.jpg",
  },
];



// WEBPACK FOOTER //
// ./src/about/components/About/teamInfo.js